import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    refresh: false,
    domain: process.env.NODE_ENV === 'production' ? '' : 'http://192.168.81.200',
    token: '',
    refreshToken:'',
    cashierConfig:{},
    //globalTitle       全局标题，浏览器头部标题
    //scanTitle         正扫页面标题
    //payTitle          收银台、匿名收银台、支付结果页面的标题
    //globalFooterShow  收银台、匿名收银台、支付结果页面底部技术支持是否显示 true *false
    //globalFooter      收银台、匿名收银台、支付结果页面底部技术支持文字
    //scanPrivilegesShow正扫页面登录优惠是否显示 *true false
    //scanPayTypeShow   正扫页面支付方式是否显示 *true false
    //forgotPasswordShow登录页面忘记密码是否显示 *true false
    //payPasswordTitle  收银台、正扫页面 支付密码弹出层的标题
    //addBankPrompt     可添加银行卡提示
    //logoTitle         pc端头部logo后的文字标题
    //hideFeaturePages  pc端哪些页面需要隐藏头部右侧信息
  },
  mutations: {
    //保存token
    setToken(state, data) {
      state.token = data.token;
      state.refreshToken = data.refreshToken;
    },
    // 退出登录，清除token和realName
    logout(state) {
      state.token = '';
      state.refreshToken = '';
    },
    //全局配置
    setCashierConfig(state, data) {
      state.cashierConfig = data;
    },
  },
  getters:{
    domain(state){
      return state.domain
    },
    token(state){
      return state.token || localStorage.getItem('cashier-pc-v2-token')
    },
    cashierConfig(state){
      return state.cashierConfig
    }
  },
  actions: {
    loginSuccess({commit},data){
      commit('setToken',data);
    },
    logout({commit}){
      localStorage.removeItem('cashier-pc-v2-token');
      localStorage.removeItem('cashier-pc-v2-refreshToken');
      commit('logout')
    },
    cashierConfigActions({commit},data){
      commit('setCashierConfig',data);
    }
  }
})